/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  BadgeComponentConfig,
  BadgeComponentConfig$inboundSchema,
  BadgeComponentConfig$Outbound,
  BadgeComponentConfig$outboundSchema,
} from "./badgecomponentconfig.js";
import {
  ButtonComponentActionConfig,
  ButtonComponentActionConfig$inboundSchema,
  ButtonComponentActionConfig$Outbound,
  ButtonComponentActionConfig$outboundSchema,
} from "./buttoncomponentactionconfig.js";
import {
  DropdownComponentActionConfig,
  DropdownComponentActionConfig$inboundSchema,
  DropdownComponentActionConfig$Outbound,
  DropdownComponentActionConfig$outboundSchema,
} from "./dropdowncomponentactionconfig.js";

/**
 * The kind of action component.
 */
export const ActionComponentConfigKind = {
  Button: "button",
  Dropdown: "dropdown",
  Badge: "badge",
} as const;
/**
 * The kind of action component.
 */
export type ActionComponentConfigKind = OpenEnum<
  typeof ActionComponentConfigKind
>;

/**
 * The config of the action component. Must contain one of button_config or dropdown_config.
 */
export type ActionComponentConfig = {
  /**
   * The config of the badge component.
   */
  badgeComponentConfig?: BadgeComponentConfig | undefined;
  /**
   * The config of the button
   */
  buttonComponentActionConfig?: ButtonComponentActionConfig | undefined;
  /**
   * The config of the dropdown
   */
  dropdownComponentActionConfig?: DropdownComponentActionConfig | undefined;
  /**
   * The kind of action component.
   */
  kind: ActionComponentConfigKind;
};

/** @internal */
export const ActionComponentConfigKind$inboundSchema: z.ZodType<
  ActionComponentConfigKind,
  z.ZodTypeDef,
  unknown
> = openEnums.inboundSchema(ActionComponentConfigKind);
/** @internal */
export const ActionComponentConfigKind$outboundSchema: z.ZodType<
  string,
  z.ZodTypeDef,
  ActionComponentConfigKind
> = openEnums.outboundSchema(ActionComponentConfigKind);

/** @internal */
export const ActionComponentConfig$inboundSchema: z.ZodType<
  ActionComponentConfig,
  z.ZodTypeDef,
  unknown
> = z.object({
  badge_component_config: types.optional(BadgeComponentConfig$inboundSchema),
  button_component_action_config: types.optional(
    ButtonComponentActionConfig$inboundSchema,
  ),
  dropdown_component_action_config: types.optional(
    DropdownComponentActionConfig$inboundSchema,
  ),
  kind: ActionComponentConfigKind$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "badge_component_config": "badgeComponentConfig",
    "button_component_action_config": "buttonComponentActionConfig",
    "dropdown_component_action_config": "dropdownComponentActionConfig",
  });
});
/** @internal */
export type ActionComponentConfig$Outbound = {
  badge_component_config?: BadgeComponentConfig$Outbound | undefined;
  button_component_action_config?:
    | ButtonComponentActionConfig$Outbound
    | undefined;
  dropdown_component_action_config?:
    | DropdownComponentActionConfig$Outbound
    | undefined;
  kind: string;
};

/** @internal */
export const ActionComponentConfig$outboundSchema: z.ZodType<
  ActionComponentConfig$Outbound,
  z.ZodTypeDef,
  ActionComponentConfig
> = z.object({
  badgeComponentConfig: BadgeComponentConfig$outboundSchema.optional(),
  buttonComponentActionConfig: ButtonComponentActionConfig$outboundSchema
    .optional(),
  dropdownComponentActionConfig: DropdownComponentActionConfig$outboundSchema
    .optional(),
  kind: ActionComponentConfigKind$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    badgeComponentConfig: "badge_component_config",
    buttonComponentActionConfig: "button_component_action_config",
    dropdownComponentActionConfig: "dropdown_component_action_config",
  });
});

export function actionComponentConfigToJSON(
  actionComponentConfig: ActionComponentConfig,
): string {
  return JSON.stringify(
    ActionComponentConfig$outboundSchema.parse(actionComponentConfig),
  );
}
export function actionComponentConfigFromJSON(
  jsonString: string,
): SafeParseResult<ActionComponentConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ActionComponentConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ActionComponentConfig' from JSON`,
  );
}
